<template>
  <h3>Big 2 Stat Charts</h3>
  <div class="dropdown-group">
    <div class="select-container">
      <div>
        <select id="first-dropdown" v-model="player1" @change="getLatestRecords(player1)" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer mt-2">
          <option v-for="player in uniquePlayers" :key="player" :value="player">{{ player }}</option>
        </select>
      </div>
    </div>

    <div class="select-container">
      <div>
        <select id="second-dropdown" v-model="player2" @change="getLatestRecords(player2)" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer mt-2">
          <option v-for="player in uniquePlayers" :key="player" :value="player">{{ player }}</option>
        </select>
      </div>
    </div>

    <div class="select-container">
      <div>
        <select id="third-dropdown" v-model="player3" @change="getLatestRecords(player3)" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer mt-2">
          <option v-for="player in uniquePlayers" :key="player" :value="player">{{ player }}</option>
        </select>
      </div>
    </div>

    <div class="select-container">
      <div>
        <select id="fourth-dropdown" v-model="player4" @change="getLatestRecords(player4)" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer mt-2">
          <option v-for="player in uniquePlayers" :key="player" :value="player">{{ player }}</option>
        </select>
      </div>
    </div>
  </div>

  <h4 class="hideCharts">Hide Charts</h4>
  <div class="checkbox-group">
    <div class="checkbox-item text-center">
      <input type="checkbox" v-model="hideLineChartWeekly" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer mx-auto">
      <label class="mt-1">Weekly Average</label>
    </div>

    <div class="checkbox-item text-center">
      <input type="checkbox" v-model="hideLineChartDaily" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer mx-auto">
      <label class="mt-1">Daily Average</label>
    </div>

    <div class="checkbox-item text-center">
      <input type="checkbox" v-model="hideBarChartPercentage" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer mx-auto">
      <label class="mt-1">% Stats</label>
    </div>

    <div class="checkbox-item text-center">
      <input type="checkbox" v-model="hideBarChart" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer mx-auto">
      <label class="mt-1">Stats</label>
    </div>
  </div>

  <div class="page-container">
    <div :class="{ 'hidden': hideLineChartWeekly }" class="lineChart-container">
      <Line
        :data="lineChartData"
        :options="lineChartOptions" 
      />
    </div>

    <div :class="{ 'hidden': hideLineChartDaily }" class="lineChart-container">
      <Line
        :data="lineChartDailyData"
        :options="lineChartDailyOptions" 
      />
    </div>

    <div :class="{ 'hidden': hideBarChartPercentage }" class="barChart-container">
      <Bar 
        :data="barChartPercentageData" 
        :options="barChartPercentageOptions"
       />
    </div>

    <div :class="{ 'hidden': hideBarChart }" class="barChart-container">
      <Bar 
        :data="barChartData" 
        :options="barChartOptions"
       />
    </div>
    
  </div>
  
</template>
  
<script>
  import axios from 'axios';
  import { Line } from 'vue-chartjs'
  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, BarElement, LineElement, Title, RadialLinearScale, Tooltip, Legend, ArcElement } from 'chart.js'
  
  ChartJS.register(CategoryScale, LinearScale, PointElement, BarElement, LineElement, Title, RadialLinearScale, ArcElement, Tooltip, Legend)

  export default {
    name: 'BigChartsPage',
    components: { 
      Line,
      Bar,
    },
    props: {
      msg: String
    },
    data() {
      return {
        apiData: [], 
        big2ApiData: [],
        playerStatsArray: [],
        player1: null,
        player2: null,
        player3: null,
        player4: null,
        hideLineChartWeekly: false,
        hideBarChartPercentage: false,
        hideBarChart: false,
        hideLineChartDaily: false,
      };
    },
    computed: {
      uniquePlayers () {
        const allPlayers = this.apiData.map(({ player }) => player);
        const sortedPlayers = allPlayers.sort((a, b) => a.localeCompare(b));
        const uniquePlayers = [null, ...new Set(sortedPlayers)];

        return uniquePlayers;
      },
      barChartData() {
        return {
          labels: ['Wins', 'Seconds', 'Thirds', 'Losses', 'Games'],
          datasets: [
            {
              label: this.player1,
              backgroundColor: '#ff0000',
              borderColor: '#ff0000',
              data: this.getLatestRecords(this.player1),
            },
            {
              label: this.player2,
              backgroundColor: '#2387c5',
              borderColor: '#2387c5',
              data: this.getLatestRecords(this.player2),
            },
            {
              label: this.player3,
              backgroundColor: '#008000',
              borderColor: '#008000',
              data: this.getLatestRecords(this.player3),
            },
            {
              label: this.player4,
              backgroundColor: '#fcba03',
              borderColor: '#fcba03',
              data: this.getLatestRecords(this.player4),
            }
          ]
        }
      },
      barChartPercentageData() {
        return {
          labels: ['Win %', 'Second %', 'Third %', 'Loss %'],
          datasets: [
            {
              label: this.player1,
              backgroundColor: '#ff0000',
              borderColor: '#ff0000',
              data: this.getLatestPercentageRecords(this.player1),
            },
            {
              label: this.player2,
              backgroundColor: '#2387c5',
              borderColor: '#2387c5',
              data: this.getLatestPercentageRecords(this.player2),
            },
            {
              label: this.player3,
              backgroundColor: '#008000',
              borderColor: '#008000',
              data: this.getLatestPercentageRecords(this.player3),
            },
            {
              label: this.player4,
              backgroundColor: '#fcba03',
              borderColor: '#fcba03',
              data: this.getLatestPercentageRecords(this.player4),
            }
          ]
        }
      },
      lineChartData() {
        return {
          labels: this.getDateLabels(this.player1, this.player2, this.player3, this.player4, 'weekly'),
          datasets: [
            {
              label: this.player1,
              backgroundColor: '#ff0000',
              borderColor: '#ff0000',
              data: this.getLineChartData(this.getDateLabels(this.player1, undefined, undefined, undefined, 'weekly'), this.player1),
            },
            {
              label: this.player2,
              backgroundColor: '#2387c5',
              borderColor: '#2387c5',
              data: this.getLineChartData(this.getDateLabels(this.player2, undefined, undefined, undefined, 'weekly'), this.player2),
            },
            {
              label: this.player3,
              backgroundColor: '#008000',
              borderColor: '#008000',
              data: this.getLineChartData(this.getDateLabels(this.player3, undefined, undefined, undefined, 'weekly'), this.player3),
            },
            {
              label: this.player4,
              backgroundColor: '#fcba03',
              borderColor: '#fcba03',
              data: this.getLineChartData(this.getDateLabels(this.player4, undefined, undefined, undefined, 'weekly'), this.player4),
            }
          ]
        }
      },
      lineChartDailyData() {
        return {
          labels: this.getDateLabels(this.player1, this.player2, this.player3, this.player4,  'daily'),
          datasets: [
            {
              label: this.player1,
              backgroundColor: '#ff0000',
              borderColor: '#ff0000',
              data: this.getLineChartData(this.getDateLabels(this.player1, undefined, undefined, undefined, 'daily'), this.player1),
            },
            {
              label: this.player2,
              backgroundColor: '#2387c5',
              borderColor: '#2387c5',
              data: this.getLineChartData(this.getDateLabels(this.player2, undefined, undefined, undefined, 'daily'), this.player2),
            },
            {
              label: this.player3,
              backgroundColor: '#008000',
              borderColor: '#008000',
              data: this.getLineChartData(this.getDateLabels(this.player3, undefined, undefined, undefined, 'daily'), this.player3),
            },
            {
              label: this.player4,
              backgroundColor: '#fcba03',
              borderColor: '#fcba03',
              data: this.getLineChartData(this.getDateLabels(this.player4, undefined, undefined, undefined, 'daily'), this.player4),
            }
          ]
        }
      },
      lineChartOptions() {
        return {
          maintainAspectRatio: false,
          responsive: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            y: {
              min: 2,
              max: 4,
              ticks: {
                beginAtZero: false,
                autoSkip: false, 
                stepSize: 0.05,
              },
              reverse: true,
            },
          },
          plugins: {
            title: {
              display: true,
              text: "Average Finishing Position (Weekly)",
            },
          },
        }
      },
      lineChartDailyOptions() {
        return {
          maintainAspectRatio: false,
          responsive: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            y: {
              min: 2,
              max: 4,
              ticks: {
                beginAtZero: false,
                autoSkip: false, 
                stepSize: 0.05,
              },
              reverse: true,
            },
          },
          plugins: {
            title: {
              display: true,
              text: "Average Finishing Position (Daily)",
            },
          },
        }
      },
      barChartOptions() {
        return {
          type: 'bar',
          maintainAspectRatio: false,
          responsive: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            title: {
              display: true,
              text: "Player Stats"
            },
          }
        }
      },
      barChartPercentageOptions() {
        return {
          type: 'bar',
          maintainAspectRatio: false,
          responsive: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            title: {
              display: true,
              text: "Player Percentage Stats"
            },
          }
        }
      },
    },
    methods: {
      getLatestRecord(playerName, apiData) {
        const playerRecords = apiData.filter(record => record.player === playerName);
        playerRecords.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        return playerRecords.length > 0 ? playerRecords[0] : null;
      },
      getOldestRecord(playerName, apiData) {
          const playerRecords = apiData.filter(record => record.player === playerName);
          playerRecords.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
          return playerRecords.length > 0 ? playerRecords[0] : null;
      },
      getLatestRecords(player) {
        if (player == null) {
          return [0, 0, 0, 0];
        }
        else{
          const latestRecord = this.getLatestRecord(player, this.apiData);
          return [latestRecord.wins, latestRecord.seconds, latestRecord.thirds, latestRecord.losses, latestRecord.gamesPlayed];
        }
      },
      getLatestPercentageRecords(player) {
        if (player == null) {
          return [0, 0, 0, 0];
        }
        else{
          const latestRecord = this.getLatestRecord(player, this.apiData);
          return [latestRecord.winPercentage, latestRecord.secondPercentage, latestRecord.thirdPercentage, latestRecord.lossPercentage];
        }
      },
      getDateLabels(player1, player2, player3, player4, dateToggle){
        if(player1 == null && player2 == null && player3 == null  && player4 == null) {
          return ['N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A'];
        }
        else if(player1 != null){
          const latestRecord = this.getLatestRecord(player1, this.apiData);
          if (latestRecord) {
            const newestDate = new Date(latestRecord.created_at);
            newestDate.setDate(newestDate.getDate() + 1);

            const dateArray = [];
            let currentDate = new Date(newestDate);

            if(dateToggle == 'daily'){
              currentDate.setDate(currentDate.getDate() - 16); 
            }
            else if(dateToggle == 'weekly'){
              currentDate.setDate(currentDate.getDate() - 105); 
            }

            while (currentDate <= newestDate) {
                const formattedDate = new Intl.DateTimeFormat('en-US', {
                    year: '2-digit',
                    day: '2-digit',
                    month: 'short',
                  }).format(currentDate);

                dateArray.push(formattedDate);

                if(dateToggle == 'daily'){
                  currentDate.setDate(currentDate.getDate() + 1);
                }
                else if(dateToggle == 'weekly'){
                  currentDate.setDate(currentDate.getDate() + 7);
                }
              }

            return dateArray;
          }
          else {
            return ['No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date'];
          }
        }
        else if(player1 == null && player2 != null){
          const latestRecord = this.getLatestRecord(player2, this.apiData);

          if (latestRecord) {
            const newestDate = new Date(latestRecord.created_at);
            newestDate.setDate(newestDate.getDate() + 1);

            const dateArray = [];
            let currentDate = new Date(newestDate);
            currentDate.setDate(currentDate.getDate() - 49); 

            while (currentDate <= newestDate) {
                const formattedDate = new Intl.DateTimeFormat('en-US', {
                    year: '2-digit',
                    day: '2-digit',
                    month: 'short',
                  }).format(currentDate);

                dateArray.push(formattedDate);
                currentDate.setDate(currentDate.getDate() + 7);
            }

            return dateArray;
          }
          else {
            return ['No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date'];
          }
        }
        else if(player1 == null && player2 == null && player3 != null){
          const latestRecord = this.getLatestRecord(player3, this.apiData);

          if (latestRecord) {
            const newestDate = new Date(latestRecord.created_at);
            newestDate.setDate(newestDate.getDate() + 1);

            const dateArray = [];
            let currentDate = new Date(newestDate);
            currentDate.setDate(currentDate.getDate() - 49); 

            while (currentDate <= newestDate) {
                const formattedDate = new Intl.DateTimeFormat('en-US', {
                    year: '2-digit',
                    day: '2-digit',
                    month: 'short',
                  }).format(currentDate);

                dateArray.push(formattedDate);
                currentDate.setDate(currentDate.getDate() + 7);
            }

            return dateArray;
          }
          else {
            return ['No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date'];
          }
        }
        else if(player1 == null && player2 == null && player3 == null && player4 != null){
          const latestRecord = this.getLatestRecord(player4, this.apiData);

          if (latestRecord) {
            const newestDate = new Date(latestRecord.created_at);
            newestDate.setDate(newestDate.getDate() + 1);

            const dateArray = [];
            let currentDate = new Date(newestDate);
            currentDate.setDate(currentDate.getDate() - 49); 

            while (currentDate <= newestDate) {
                const formattedDate = new Intl.DateTimeFormat('en-US', {
                    year: '2-digit',
                    day: '2-digit',
                    month: 'short',
                  }).format(currentDate);

                dateArray.push(formattedDate);
                currentDate.setDate(currentDate.getDate() + 7);
            }

            return dateArray;
          }
          else {
            return ['No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date', 'No Date'];
          }
        }
      },
      parseCustomDate(dateString) {
        const dateParts = dateString.split(', ');
        const monthDay = dateParts[0];
        const hours = 23;
        const minutes = 59; 
        const month = this.parseMonth(monthDay.split(' ')[0]);
        const day = parseInt(monthDay.split(' ')[1], 10);

        let year = parseInt(dateParts[1], 10);
        year = year < 100 ? 2000 + year : year;

        const date = new Date(year, month - 1, day, hours, minutes);
        return date;
      },
      parseMonth(monthAbbreviation) {
          const months = {
            'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
            'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
          };
          return months[monthAbbreviation];
      },
      getLineChartData(dateArray, playerName){
        if (dateArray.every(date => date === 'N/A')) {
          return [];
        }
        else {
          const chartData = [];

          for (const dateString of dateArray) {
            const dateStringObject = new Date(dateString);
            const parsedDate = this.parseCustomDate(dateString);
            const today = new Date();
            
            const isSameDay = dateStringObject.getFullYear() === today.getFullYear() &&
                              dateStringObject.getMonth() === today.getMonth() &&
                              dateStringObject.getDate() === today.getDate();

            const year = parsedDate.getFullYear();
            const month = parsedDate.getMonth() + 1; 
            const day = parsedDate.getDate();
            const formattedDateForComparison = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

            const matchingRecord = this.apiData.find(
              record =>
                record.created_at.startsWith(formattedDateForComparison) &&
                record.player === playerName
            );

            if (matchingRecord) {
              chartData.push(matchingRecord.averageFinishingPosition); 
            } 
            else if(!matchingRecord && isSameDay) {
              const playerStats = this.playerStatsArray.find(player => player.name === playerName);
              chartData.push(playerStats.averageFinishingPosition);
            }
            else {
              chartData.push(null); 
            }
          }

          return chartData;
        }
      },
      calculatePlayerStats(apiData) {
      const winningCounts = {};
      const secondCounts = {};
      const thirdCounts = {};
      const losingCounts = {};
      const gamesPlayedCounts = {};

      apiData.forEach(dataItem => {
        if (dataItem.winner) {
          if (winningCounts[dataItem.winner]) {
            winningCounts[dataItem.winner]++;
          } else {
            winningCounts[dataItem.winner] = 1;
          }
        }

        if (dataItem.second) {
          if (secondCounts[dataItem.second]) {
            secondCounts[dataItem.second]++;
          } else {
            secondCounts[dataItem.second] = 1;
          }
        }

        if (dataItem.third) {
          if (thirdCounts[dataItem.third]) {
            thirdCounts[dataItem.third]++;
          } else {
            thirdCounts[dataItem.third] = 1;
          }
        }

        if (dataItem.loser) {
          if (losingCounts[dataItem.loser]) {
            losingCounts[dataItem.loser]++;
          } else {
            losingCounts[dataItem.loser] = 1;
          }
        }
      });

      apiData.forEach(dataItem => {
        dataItem.players.forEach(player => {
          if (gamesPlayedCounts[player]) {
            gamesPlayedCounts[player]++;
          } else {
            gamesPlayedCounts[player] = 1;
          }
        });
      });

      const playersWithStats = Object.keys(gamesPlayedCounts).map(player => {
        const wins = winningCounts[player] || 0;
        const seconds = secondCounts[player] || 0;
        const thirds = thirdCounts[player] || 0;
        const losses = losingCounts[player] || 0;
        const gamesPlayed = gamesPlayedCounts[player] || 0;

        const totalPoints = wins * 1 + seconds * 2 + thirds * 3 + losses * 4;
        const averageFinishingPosition = (totalPoints / gamesPlayed).toFixed(3);

        const winPercentage = ((wins / gamesPlayed) * 100).toFixed(2); 
        const secondPercentage = ((seconds / gamesPlayed) * 100).toFixed(2); 
        const thirdPercentage = ((thirds / gamesPlayed) * 100).toFixed(2); 
        const lossPercentage = ((losses / gamesPlayed) * 100).toFixed(2); 
        const gamePercentage = ((gamesPlayed / this.apiData.length) * 100).toFixed(2);
        
        return {
          name: player,
          wins,
          seconds,
          thirds,
          losses,
          gamesPlayed,
          gamePercentage,
          winPercentage,
          secondPercentage,
          thirdPercentage,
          lossPercentage,
          averageFinishingPosition,
        };
      });

      return playersWithStats;
    },
    },
    created() {
      document.title = 'Big 2 Charts'; 
      axios.get('https://kbcardgames.xyz/api/player-statistics/')
        .then(response => {
          this.apiData = response.data;
          console.log('API request successful:', response);
        })
        .catch(error => {
          console.error('Error:', error);
        });

      axios.get('https://kbcardgames.xyz/api/big2-statistics/')
        .then(response => {
          this.big2ApiData = response.data; 
          this.playerStatsArray = this.calculatePlayerStats(this.big2ApiData);
          console.log(this.playerStatsArray);
          console.log('Second API request successful:', response);
        })
        .catch(error => {
          console.error('Error with the second API:', error);
        });
    },
  }
</script>
  
<style scoped>
@font-face {
  font-family: 'Formula1-Regular';
  src: url('@/assets/fonts/Formula1-Regular.otf') format('opentype'); 
}

@font-face {
  font-family: 'Formula1-Bold';
  src: url('@/assets/fonts/Formula1-Bold.otf') format('opentype'); 
}

h3{
  font-family: 'Formula1-Bold', sans-serif;
  margin-top: 15px;
}

.hideCharts {
  margin-bottom: 2px;
  font-size: 14px; 
  font-family: 'Formula1-regular', sans-serif;
  margin-top: 20px;
}

.dropdown-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around; 
}

.select-container {
  flex: 0 0 calc(50% - 10px); 
  margin-top: 5px;
  margin-bottom: 0px; 
}

/* Removed old select styles since Tailwind handles width and padding now */
select {
  font-family: 'Formula1-Regular', sans-serif;
}

label {
  font-size: 10px;
  font-family: 'Formula1-regular', sans-serif;
  display: block;
}

.checkbox-group {
  border: 1px solid #ccc; 
  border-radius: 10px;
  padding: 5px 0; 
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 400px; 
}

.checkbox-item {
  flex: 0 0 calc(25% - 10px); 
  margin-right: 10px; 
}

.hidden {
  display: none;
}

.barChart-container {
  border: 1px solid #ccc; 
  border-radius: 10px;
  position: relative;
  margin-top: 12px; 
  margin-bottom: 50px;
  height: 400px;
  width: 360px;
}

.lineChart-container{
  border: 1px solid #ccc; 
  border-radius: 10px;
  position: relative;
  margin-top: 12px;
  margin-bottom: 50px;
  height: 750px;
  width: 360px;
}

.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh; 
}
</style>